import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../css/public/privacy-policy.css';
import TopBar from './NavBar';
import Footer from './../components/Footer';

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = 'Privacy Policy | Aadow';
	  }, []);
 

  return (
    <div class="privacy-policy-body">
	<TopBar />
	<div class="top-area">
      <div class="container-top text-center">
        <h1>PRIVACY POLICY</h1>
		<span>Updated on 20 May 2025</span>
      </div>
    </div>
    <div class="content-area"> 
	
	<div class="policy-content shadow-sm">
		<p>At Aadow, we are committed to protecting your privacy and safeguarding the personal information you provide to us. This Privacy Policy outlines how we collect, use, disclose, and store your personal information when you engage with our services. By using our services, you consent to the practices described in this policy.</p>

		<h2>Email Marketing Data:</h2>
		<p>a. <strong>Email Lists and Customer Data:</strong> We will not sell, rent, or share your customer's email lists or any other personal data with third parties, except as described in this Privacy Policy or with your explicit consent.</p>
		<p>b. <strong>Data Processing:</strong> We process email data solely for delivering services like campaign delivery and analytics, based strictly on your instructions and as required for service functionality.</p>
		<p>c. <strong>Data Security:</strong> Industry-standard security measures are in place, including encryption and access controls.</p>
		<p>d. <strong>Data Retention:</strong> Data is retained only as long as necessary for service delivery or legal obligations.</p>
		<p>e. <strong>Compliance with Regulations:</strong> We comply with applicable laws including GDPR and other global data protection laws.</p>
		<p>f. <strong>Data Controller Responsibilities:</strong> You are the data controller and are responsible for obtaining proper consent. We act as a data processor on your behalf.</p>
		<p>g. <strong>Subprocessors:</strong> We may engage subprocessors (e.g., email services, analytics) who meet strict security and compliance standards.</p>
		<p>h. <strong>Policy Updates:</strong> Any updates to data handling practices will be posted here or communicated to you.</p>

		<h2>WhatsApp Data:</h2>
		<p>a. <strong>WhatsApp API Usage:</strong> Our WhatsApp services are powered by Meta’s official WhatsApp Business API. All messages are transmitted securely through Meta’s infrastructure.</p>
		<p>b. <strong>Message & Contact Data:</strong> We collect and process WhatsApp messages, contact phone numbers, and metadata solely to enable features such as chat inbox, message templates, automation flows, and campaign performance analytics.</p>
		<p>c. <strong>User Consent & Compliance:</strong> You are responsible for obtaining end-user consent before initiating WhatsApp messages. You must comply with WhatsApp’s Business and Commerce Policies.</p>
		<p>d. <strong>Data Retention:</strong> We retain WhatsApp-related data only for as long as needed to deliver services or comply with applicable legal obligations.</p>
		<p>e. <strong>Security:</strong> Industry-standard encryption, access control, and secure infrastructure are used to protect all WhatsApp data.</p>

		<h2>Information We Collect:</h2>
		<p>a. <strong>Personal Information:</strong> Name, email, contact details, etc.</p>
		<p>b. <strong>Payment Information:</strong> We may collect billing information (processed securely by third-party providers).</p>
		<p>c. <strong>Usage Information:</strong> Includes IP address, browser details, and interaction data collected via cookies and analytics tools.</p>

		<h2>Use of Information:</h2>
		<p>a. <strong>Service Delivery:</strong> To provide and maintain our services, including email campaigns, WhatsApp messaging, and automation flows.</p>
		<p>b. <strong>Improvement:</strong> Analyze usage to enhance service performance.</p>
		<p>c. <strong>Marketing Communications:</strong> With your explicit consent, we may send marketing or promotional content. You may opt-out at any time via unsubscribe links or by contacting us.</p>
		<p>d. <strong>Legal Compliance:</strong> To comply with laws and enforce our rights.</p>

		<h2>Legal Basis for Processing (GDPR):</h2>
		<p>We process your personal data based on one or more of the following legal bases: (i) your consent; (ii) performance of a contract; (iii) legal obligations; (iv) legitimate interests (e.g., service improvement, fraud prevention).</p>

		<h2>Disclosure of Information:</h2>
		<p>a. <strong>Third-Party Providers:</strong> Only trusted partners involved in delivering our services, bound by strict confidentiality agreements.</p>
		<p>b. <strong>Legal Disclosures:</strong> Required by law or in defense of our legal rights.</p>

		<h2>Data Security:</h2>
		<p>We implement appropriate technical and organizational measures to secure your information. However, no online system is completely secure.</p>

		<h2>Data Retention:</h2>
		<p>We retain data only as long as necessary to fulfill the purpose it was collected for or as required by law. Secure deletion or anonymization follows expiration.</p>

		<h2>International Data Transfers:</h2>
		<p>Your data may be transferred to and processed in countries outside your own, including countries where data protection laws may differ. We ensure appropriate safeguards are in place.</p>

		<h2>Children’s Privacy:</h2>
		<p>Our services are not intended for individuals under the age of 13. We do not knowingly collect personal data from children. If you believe we have done so, please contact us for deletion.</p>

		<h2>Third-Party Links:</h2>
		<p>Our platform may contain links to third-party websites. We are not responsible for their privacy practices and recommend reviewing their privacy policies before sharing personal data.</p>
		<p>We may use trusted subprocessors (e.g., Meta for WhatsApp messaging) who follow strict privacy and compliance standards.</p>
		<h2>Your Rights:</h2>
		<p>You have the right to access, update, correct, delete, or restrict your personal data. You may also object to processing or request data portability. To exercise any of these rights, contact us using the details below.</p>

		<h2>Cookies and Tracking:</h2>
		<p>We use cookies and similar technologies to improve user experience, track site usage, and personalize content. By using our site, you consent to our use of cookies. You can modify your browser settings to disable cookies, but some features may not work properly.</p>

		<h2>Policy Changes:</h2>
		<p>We may update this Privacy Policy from time to time. The updated version will be indicated by an updated “Effective Date” below and will be effective as soon as it is accessible. We recommend checking periodically for changes.</p>

		<h2>Effective Date:</h2>
		<p>This Privacy Policy is effective as of May 25, 2025.</p>

		<h2>Contact Us:</h2>
		<p>If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at: <a href="mailto:Contact@aadow.com">Contact@aadow.com</a></p>
		</div>
	 
	</div>
	<Footer/>
    </div>
  );
};

export default PrivacyPolicy;
